export const getPaginationValues = ({ itemsCount, pageNumber, pageSize, }) => {
    const pagesCount = Math.ceil(itemsCount / pageSize);
    const startRange = (pageNumber - 1) * pageSize + 1;
    const endRange = (pageNumber === pagesCount ? itemsCount : startRange + pageSize - 1);
    return {
        pagesCount,
        startRange,
        endRange,
    };
};
/**
 * Translates a page number from one page size to another.
 *
 * Given a backend page/size pair, returns the page number at which
 * the first item on that backend page would appear under `feSize`.
 *
 * @param bePage - Page number returned by the backend (1-based).
 * @param beSize - Page size used by the backend.
 * @param feSize - Current frontend page size.
 * @returns The 1-based page number in the frontend, or null if inputs are invalid.
 *
 * @example
 * translatePageToCurrentSize(10, 10, 24) // → 4
 * // itemStartIndex = (10-1)*10+1 = 91; ceil(91/24) = 4
 */
export const translatePageToCurrentSize = (bePage, beSize, feSize) => {
    if (!bePage || !beSize || feSize <= 0) {
        return null;
    }
    const itemStartIndex = (bePage - 1) * beSize + 1;
    return Math.ceil(itemStartIndex / feSize);
};
